import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import {TextField} from 'rmwc/TextField';

import StatusMessage from '../../util/StatusMessage'

class AdminAddCouponsToRetail extends Component{

	constructor(props){
    super(props);
    this.state={
      data: {
      	userId:0,
        tqCertId:0,
      },
      formErrors: {
        userIdError:'',
        tqCertIdError:'',
      },
      errorMsg: '',
      buttonDisable: false
    }
  }

	componentDidMount() {
    
  }

  validateForm(){

    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)

    errorObj.userIdError = ''
    errorObj.tqCertIdError = ''

    if(!(data.userId) || data.userId === ''){
      errorObj.userIdError ='User Id is mandatory is mandatory'
      error = false
    }

    if(!(data.tqCertId) || data.tqCertId === ''){
      errorObj.tqCertIdError ='TQ Certification Id is mandatory'
      error = false
    }
   

    this.setState({
      formErrors:errorObj,
      errorMsg:'',
      buttonDisable: false
    })
    return error
  }

  

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  
  goBack = () => {
    this.props.history.push('/portal/app/admin/coupons')
  }

  handleRetailAllocation = (event) => {
    event.preventDefault()
    let data = Object.assign({}, this.state.data)
    this.setState({buttonDisable: true})
    if(this.validateForm()) {
      let apiInput = {
        'user_id': data.userId,
        'tq_id': data.tqCertId,
      }

      
    api.adminCouponAllocationRetailManual(this.props.user.accessToken, apiInput)
      .then((result) => {     
        if(result.status === 'success') {
          this.setState({ errorMsg: result.message,buttonDisable: true })
        }
        else{
          this.setState({errorMsg: result.message,buttonDisable: false})
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: 'Error encountered during allocation',buttonDisable: false })
      })
    }
  }

	render() {
		return (
			<form onSubmit={(e) => this.handleRetailAllocation(e)} style={{width: '100%'}}>
        <Card style={{padding: '25px'}}>
          <Grid>
            <GridCell span="10"><Typography use="headline5">Allocate to Retail Registration-  This is for correcting cases where there was no coupon allocated in normal flow</Typography></GridCell>
            <GridCell span="2"><Button raised onClick={this.goBack}>Go Back</Button></GridCell>
          </Grid>
          <Grid className="opportunity-list-item">

            <GridCell span="6">
              <TextField fullwidth className='text_input' label="User ID" autoComplete="off"  type="number" name="userId" onChange={this.onInputChange} value={this.state.data.userId}/>
            </GridCell>
            <GridCell span="6"/>
            
            
            <GridCell span="6">
              <TextField fullwidth className='text_input' label="TQ Certificaiton Id (From Export)" type="number" autoComplete="off"  name="tqCertId" onChange={this.onInputChange} value={this.state.data.tqCertId}/>
            </GridCell>
            <GridCell span="6"/>
            <GridCell span="6">
              <Button raised disabled={this.state.buttonDisable}>Allocate</Button>
            </GridCell> 
          </Grid>
          <StatusMessage error_msg = {this.state.errorMsg}/>
          <StatusMessage error_msg = {this.state.formErrors.userIdError}/>
          <StatusMessage error_msg = {this.state.formErrors.tqCertIdError}/>

        </Card>
      </form>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminAddCouponsToRetail);


// WEBPACK FOOTER //
// ./src/views/admin/AdminAddCouponsToRetail.jsx